const currentYear = new Date().getFullYear();

export const infoKo = {
  termsOfService: '이용 약관',
  privacyPolicy: '개인정보 처리방침',
  ceo: '대표자',
  businessNumber: '사업자등록번호',
  communicationSalesRegistrationNumber: '통신판매업 신고번호',
  email: '이메일 문의',
  address: '주소',
  privacyManager: '개인정보보호책임자',
  phone: '대표전화',
  copyright: `© ${currentYear} Architrave`,
};

export const infoEn = {
  termsOfService: 'Terms of Service',
  privacyPolicy: 'Privacy Policy',
  ceo: 'CEO',
  businessNumber: 'Business Registration No.',
  communicationSalesRegistrationNumber: 'E-commerce Registration No.',
  email: 'Email',
  address: 'Address',
  privacyManager: 'Data Protection Officer(DPO)',
  phone: 'Tel',
  copyright: `© ${currentYear} Architrave`,
};

export const companyKo = {
  name: '아키트레이브',
  ceo: '김영동',
  businessNumber: '331-24-02188',
  communicationSalesRegistrationNumber: '2025-용인기흥-02536',
  email: 'architrave2025@gmail.com',
  address: '경기도 용인시 기흥구 마북로 154번길 23',
  phone: '010-5049-5056',
  privacyManager: '김영동',
};

export const companyEn = {
  name: 'Architrave',
  ceo: 'KIM YOUNGDONG',
  businessNumber: '331-24-02188',
  communicationSalesRegistrationNumber: '2025-용인기흥-02536',
  email: 'architrave2025@gmail.com',
  address: '23, Mabuk-ro 154beon-gil, Giheung-gu, Yongin-si, Gyeonggi-do, Republic of Korea',
  phone: '+82-10-5049-5056',
  privacyManager: 'KIM YOUNGDONG',
};